import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d93d97f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "documents-file-container py-56" }
const _hoisted_2 = { class: "top-section d-flex align-items-center justify-content-between" }
const _hoisted_3 = { class: "document-type d-flex align-items-center flex-wrap" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "view-tabs" }, [
  /*#__PURE__*/_createElementVNode("ul", {
    class: "nav nav-tabs border-0",
    id: "myTab",
    role: "tablist"
  }, [
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        class: "btn btn-icon p-8 active",
        id: "grid-tab",
        "data-bs-toggle": "tab",
        "data-bs-target": "#grid",
        type: "button",
        role: "tab",
        "aria-controls": "grid",
        "aria-selected": "true"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "icon icon-grid" })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", {
      class: "nav-item",
      role: "presentation"
    }, [
      /*#__PURE__*/_createElementVNode("button", {
        class: "btn btn-icon p-8",
        id: "list-tab",
        "data-bs-toggle": "tab",
        "data-bs-target": "#list",
        type: "button",
        role: "tab",
        "aria-controls": "list",
        "aria-selected": "false"
      }, [
        /*#__PURE__*/_createElementVNode("span", { class: "icon icon-table" })
      ])
    ])
  ])
], -1))
const _hoisted_5 = { class: "tab-content" }
const _hoisted_6 = {
  class: "tab-pane active",
  id: "grid",
  role: "tabpanel",
  "aria-labelledby": "grid-tab"
}
const _hoisted_7 = {
  class: "tab-pane list-component",
  id: "list",
  role: "tabpanel",
  "aria-labelledby": "list-tab"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_the_patient_document_grid = _resolveComponent("the-patient-document-grid")!
  const _component_the_patient_document_list = _resolveComponent("the-patient-document-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formsSettings.uploaded_media_category_options, (type) => {
          return (_openBlock(), _createBlock(_component_v_button, {
            key: type.key,
            variant: "filter",
            class: _normalizeClass(["me-8 mb-8 mb-lg-0", {'active': _ctx.typeSelected === type.key }]),
            onClick: ($event: any) => (_ctx.typeSelected = type.key)
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(type.label), 1)
            ]),
            _: 2
          }, 1032, ["class", "onClick"]))
        }), 128))
      ]),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_the_patient_document_grid, {
          media: _ctx.media,
          status: _ctx.status,
          onRefreshMedia: _ctx.loadExpedientMedia
        }, null, 8, ["media", "status", "onRefreshMedia"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_the_patient_document_list, {
          media: _ctx.media,
          status: _ctx.status,
          onRefreshMedia: _ctx.loadExpedientMedia
        }, null, 8, ["media", "status", "onRefreshMedia"])
      ])
    ])
  ]))
}